var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: _vm.classContainer, attrs: { id: "page-container" } },
    [
      _c("attendance-alert", { attrs: { cnt_attendance: _vm.cnt_attendance } }),
      _c("landing-event-modal"),
      _c("event-modal", { attrs: { usrAttend: _vm.cnt_attendance } }),
      _c("div", {
        class: { show: _vm.$store.state.settings.pageLoader },
        attrs: { id: "page-loader" },
      }),
      _vm.$store.state.layout.sideOverlay &&
      _vm.$store.state.settings.pageOverlay
        ? _c("div", {
            attrs: { id: "page-overlay" },
            on: {
              click: () => _vm.$store.commit("sideOverlay", { mode: "close" }),
            },
          })
        : _vm._e(),
      _vm.$store.state.layout.sideOverlay
        ? _c(
            "base-side-overlay",
            { class: _vm.layoutClasses.sideOverlay },
            [_vm._t("side-overlay")],
            2
          )
        : _vm._e(),
      _vm.$store.state.layout.sidebar
        ? _c(
            "base-sidebar",
            { class: _vm.layoutClasses.sidebar },
            [_vm._t("sidebar")],
            2
          )
        : _vm._e(),
      _vm.$store.state.layout.header
        ? _c(
            "base-header",
            { class: _vm.layoutClasses.header },
            [_vm._t("header")],
            2
          )
        : _vm._e(),
      _c(
        "div",
        { attrs: { id: "main-container" } },
        [_vm._t("content"), _c("router-view")],
        2
      ),
      _vm.$store.state.layout.footer
        ? _c(
            "base-footer",
            { class: _vm.layoutClasses.footer },
            [_vm._t("footer")],
            2
          )
        : _vm._e(),
      _c("Spinner", {
        attrs: {
          loading: _vm.loadingStatus,
          loading_content: _vm.loadingContent,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }